export default "__VITE_ASSET__CfWTqNgz__"